
import { defineComponent, ref } from "vue";
import Dropdown3 from "@/components/dropdown/Dropdown3.vue";
import { useStore } from "vuex";
import { CookieComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "kt-account",
  components: {
    Dropdown3,
  },
  setup() {
    const store = ref(useStore());
    const imgURL = ref<string>("media/icons/duotune/arrows/arr066.svg");
    return {
      store,
      imgURL,
    };
  },
  computed: {
    user() {
      return JSON.parse(CookieComponent.get("userData") as string);
    },
  },
  methods: {},
});
